import React from "react";

import { makeStyles, Typography } from "@material-ui/core";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import DeleteIcon from "@material-ui/icons/Delete";
import ZoomInIcon from "@material-ui/icons/ZoomIn";

const useStyles = makeStyles((theme) => ({
  legend: {
    background: theme.palette.secondary.light,
    display: "inline-flex",
    alignItems: "center",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.only("xs")]: {
      display: "block",
    },
  },
  purpleCircle: {
    background: theme.palette.secondary.main,
    borderRadius: "50%",
    padding: theme.spacing(1),
    color: "#fff",
    margin: theme.spacing(0, 1, 0, 5),
    [theme.breakpoints.only("xs")]: {
      display: "inline-flex",
      margin: theme.spacing(1, 1),
    },
  },
}));

export default function Legend() {
  const classes = useStyles();
  return (
    <div className={classes.legend}>
      <Typography variant="body1">Legenda:</Typography>
      <CheckRoundedIcon className={classes.purpleCircle} />
      <Typography variant="body1">Odobri</Typography>
      <DeleteIcon className={classes.purpleCircle} />
      <Typography variant="body1">Odbij</Typography>
      <ZoomInIcon className={classes.purpleCircle} />
      <Typography variant="body1">Povećaj</Typography>
    </div>
  );
}
